import React, { useState } from 'react';

import Slide from './MapAnimationSlide';
import CustomSlider from './CustomSlider';
import PhotoCard from './PhotoCard';

import { styled } from "../../../stitches.config";
import { keyframes } from '@stitches/react';
import { animated, useTransition } from '@react-spring/web';
import dotmap from '../../../assets/img/natemat/career/dotmap.png';
import { ReactComponent as Pin } from '../../assets/icons/pin.svg?react';

export type LocationsTypes = {
    text: string,
    url: string,
    pinLocation: {
        x: string,
        y: string,
    },
}

const items: LocationsTypes[] = [
    {
        text: 'Islandia',
        url: 'https://cdn.natemat.pl/fa2c56914e420245888fe93c1500a4ec,0,0,0,0.jpg',
        pinLocation: {
            x: '42%',
            y: '11%',
        },
    },
    {
        text: 'San Francisco',
        url: 'https://cdn.natemat.pl/f82d52707be212b2bacba821a4203955,0,0,0,0.jpg',
        pinLocation: {
            x: '17.5%',
            y: '40%',
        },
    },
    {
        text: 'Arabia Saudyjska',
        url: 'https://cdn.natemat.pl/776f208049e39b1e98640fcdae4e02e0,0,0,0,0.jpg',
        pinLocation: {
            x: '60%',
            y: '30%',
        },
    },
    {
        text: 'Nowy Jork',
        url: 'https://cdn.natemat.pl/b6bc09fa524217e45e048ef1c05c00a8,0,0,0,0.jpg',
        pinLocation: {
            x: '25%',
            y: '30%',
        },
    },
    {
        text: 'Włochy',
        url: 'https://cdn.natemat.pl/f3e07608f91a81e3e0f71e60a5695b50,0,0,0,0.jpg',
        pinLocation: {
            x: '48%',
            y: '23%',
        },
    },
    {
        text: 'Tokio',
        url: 'https://cdn.natemat.pl/edbfa59d58c315f086ac3bd03b54b5f7,0,0,0,0.jpg',
        pinLocation: {
            x: '80%',
            y: '35%',
        },
    },
    {
        text: 'Norwegia',
        url: 'https://cdn.natemat.pl/bc058a0d81ebd4bb5a2fd667d374c0fc,0,0,0,0.jpg',
        pinLocation: {
            x: '47%',
            y: '12%',
        },
    },
    {
        text: 'Australia',
        url: 'https://cdn.natemat.pl/195eb8d683f5987f9e3ae0a0abeb32c3,0,0,0,0.jpg',
        pinLocation: {
            x: '85%',
            y: '75%',
        },
    },
    {
        text: 'Maroko',
        url: 'https://cdn.natemat.pl/bc058a0d81ebd4bb5a2fd667d374c0fc,0,0,0,0.jpg',
        pinLocation: {
            x: '45%',
            y: '30%',
        },
    },
    {
        text: 'Dubaj',
        url: 'https://cdn.natemat.pl/776f208049e39b1e98640fcdae4e02e0,0,0,0,0.jpg',
        pinLocation: {
            x: '63%',
            y: '35%',
        },
    },
    {
        text: 'Hiszpania',
        url: 'https://cdn.natemat.pl/f3e07608f91a81e3e0f71e60a5695b50,0,0,0,0.jpg',
        pinLocation: {
            x: '43%',
            y: '25%',
        },
    },
    {
        text: 'Francja',
        url: 'https://cdn.natemat.pl/72b63e1ca420fe399ea3bac8b22d94c3,0,0,0,0.jpg',
        pinLocation: {
            x: '46%',
            y: '20%',
        },
    }
]

const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 996,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            },
        }
    ]
}


const MapAnimation = () => {
    const [isAnimationStarted, setIsAnimationStarted] = useState<boolean>(false);
    const [index, setIndex] = useState<number>(0);
    const MapLocation: LocationsTypes = items[index];
    const transitions = useTransition(index, {
        key: index,
        from: { opacity: 0, y: 100 },
        enter: { opacity: 1, y: 0, position: 'absolute', width: '100%' },
        leave: { opacity: 0, y: 100 },
        config: {
            duration: 500,
        },
        onRest: (_a, _b, item) => {
            setTimeout(() => {
                if (index === item) {
                    setIndex(state => (state + 1) % items.length);
                }
                setIsAnimationStarted(false);
            }, 2000)
            setIsAnimationStarted(true);
        },
        exitBeforeEnter: false,
    })
    return (
        <MapWrapper>
            <AnimationContainer>
                <AnimationWrapper>
                    {transitions((style, i) => (
                        <animated.div style={style}>
                            <Slide {...items[index]} index={index}></Slide>
                        </animated.div>
                    ))}
                    <Pin style={{ left: MapLocation.pinLocation.x, top: MapLocation.pinLocation.y }} />
                </AnimationWrapper>
            </AnimationContainer >
            <CustomSlider {...settings} className='map-slider'>
                {
                    items.map((item) => {
                        return (
                            <PhotoCard url={item.url} />
                        )
                    })
                }
            </CustomSlider>
            <ProgressBar style={isAnimationStarted ? { display: 'block' } : { display: 'none' }} />
        </MapWrapper>
    )
}

export default MapAnimation;

const BarAnimation = keyframes({
    '0%': {
        width: '0%',
        opacity: 1,
    },
    '80%': {
        width: '100%',
        opacity: 1,
    },
    '100%': {
        opacity: 0,
        width: '100%',
    }
})

const MapWrapper = styled('div', {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&>svg': {

        display: 'none',
    },
    '.map-slider': {
        height: '500px',
        width: '90%',
        maxWidth: '1440px',
        alignSelf: 'center',
        marginBottom: '50px',
        '.slick-slider': {
            '.slick-list': {
                overflow: 'visible',
            },
            'ul': {
                transform: 'translateY(50px)',
                'li': {
                    background: '$grayscale0Fixed',
                    borderRadius: '50%',
                    width: '10px',
                    height: '10px',
                    opacity: 0.1,
                    'button': {
                        '&:before': {
                            content: ''
                        },
                    },
                    '&.slick-active': {
                        background: '$primary',
                        opacity: 1,
                    },
                },
            },
            '.slick-arrow': {
                display: 'none',
            },
        },

        '@bp4': {
            '&>svg': {
                display: 'block',
                position: 'absolute',
                width: '50px',
                height: '50px',
                zIndex: 0,
            },
            '.slick-slider': {
                '.slick-list': {
                    overflow: 'hidden',
                },
                '.slick-next': {
                    display: 'block',
                    background: '$natematPrimary',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    zIndex: 100,
                    transform: 'rotate(90deg) translate(-50%, 15px)',
                    '&::before': {
                        content: '',
                    },
                    '&:hover': {
                        background: '$natematPrimary',
                        cursor: 'pointer',
                    },
                    'svg': {
                        transform: 'translate(50%,50%)',
                        path: {
                            fill: '$grayscale0',
                        }
                    }
                },
                '.slick-prev': {
                    display: 'block',
                    background: '$natematPrimary',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    zIndex: 100,
                    transform: 'rotate(-90deg) translate(50%, 15px)',
                    '&::before': {
                        content: '',
                    },
                    '&:hover': {
                        background: '$natematPrimary',
                        cursor: 'pointer',
                    },
                    'svg': {
                        transform: 'translate(50%,50%)',
                        path: {
                            fill: '$grayscale0',
                        }
                    }
                },

            },
        }
    }
})

const ProgressBar = styled('div', {
    position: 'absolute',
    backgroundColor: '$primary',
    alignSelf: 'flex-start',
    bottom: 0,
    height: '10px',
    animationName: `${BarAnimation}`,
    animationDuration: '2s',
})

const AnimationWrapper = styled('div', {
    position: 'relative',
    display: 'flex',
    height: '300px',
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url("${dotmap}")`,
    backgroundSize: 'contain',
    '@bp4': {
        backgroundPosition: 'center center',
        height: '600px',
        width: '100%',
    }
})

const AnimationContainer = styled('div', {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'min-content',
    justifyContent: 'flex-end',
})

const PinIcon = styled('img', {

})